import { provideAppInitializer, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { LanguageService } from './services/language/language.service';
import { lastValueFrom } from 'rxjs';

export function prefetchLanguage() {
  const transloco = inject(TranslocoService);
  const languageService = inject(LanguageService);
  const lang = languageService.getLanguage();
  transloco.setActiveLang(lang);
  return lastValueFrom(transloco.load(lang));
}
